// Force-format dates in Europe/Paris timezone so that times stored in UTC
// always display as Paris-local hours (CET/CEST), regardless of the
// viewer's browser locale or our screenshot agents.

const PARIS = "Europe/Paris";

export function fmtDateTimeParis(iso, opts = {}) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("fr-FR", {
      timeZone: PARIS,
      dateStyle: "long",
      timeStyle: "short",
      ...opts,
    });
  } catch {
    return String(iso);
  }
}

export function fmtDateParis(iso, opts = {}) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("fr-FR", {
      timeZone: PARIS,
      dateStyle: "long",
      ...opts,
    });
  } catch {
    return String(iso);
  }
}

export function fmtDateShortParis(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("fr-FR", {
      timeZone: PARIS,
      day: "numeric",
      month: "long",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return String(iso);
  }
}

export function fmtTimeParis(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleTimeString("fr-FR", {
      timeZone: PARIS,
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return String(iso);
  }
}
